var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 29.334L14.0007 21.334H3.33398L6.00065 29.334H16.6673ZM16.6673 29.334H22.0006",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 17.334V16.6673C16.6667 14.1532 16.6667 12.8961 15.8856 12.115C15.1045 11.334 13.8475 11.334 11.3333 11.334C8.81917 11.334 7.56209 11.334 6.78105 12.115C6 12.8961 6 14.1532 6 16.6673V17.334",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 17.3327C26.0003 18.8055 24.8065 19.9993 23.3337 19.9993C21.8609 19.9993 20.667 18.8055 20.667 17.3327C20.667 15.8599 21.8609 14.666 23.3337 14.666C24.8065 14.666 26.0003 15.8599 26.0003 17.3327Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 5.33268C14.0003 6.80544 12.8064 7.99935 11.3337 7.99935C9.8609 7.99935 8.66699 6.80544 8.66699 5.33268C8.66699 3.85992 9.8609 2.66602 11.3337 2.66602C12.8064 2.66602 14.0003 3.85992 14.0003 5.33268Z",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.334 23.334H27.334C28.8068 23.334 30.0007 24.5279 30.0007 26.0007V26.6673C30.0007 28.1401 28.8068 29.334 27.334 29.334H26.0007",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame20);
export default __webpack_public_path__ + "static/media/Frame (20).ab0086cf5935d06659f29346e486312f.svg";
export { ForwardRef as ReactComponent };